import { Reveal, Overline } from "../components/Reveal";

const LegalShell = ({ overline, title, updated, children, testid }) => (
    <main data-testid={testid}>
        <section className="bg-charcoal pb-16 pt-40 text-ivory md:pb-20 md:pt-52">
            <div className="mx-auto max-w-[1400px] px-6 md:px-12">
                <Reveal>
                    <Overline>{overline}</Overline>
                    <h1 className="mt-6 font-serif text-5xl font-light leading-[1.02] tracking-tight sm:text-6xl">{title}</h1>
                    <p className="mt-4 text-xs font-light uppercase tracking-[0.2em] text-ivory/50">{updated}</p>
                </Reveal>
            </div>
        </section>
        <section className="mx-auto max-w-3xl px-6 py-20 md:py-28">
            <div className="space-y-10 text-sm font-light leading-relaxed text-ink/75">{children}</div>
        </section>
    </main>
);

const H = ({ children }) => (
    <h2 className="font-serif text-2xl font-medium tracking-tight text-ink">{children}</h2>
);

export const PrivacyPolicy = () => (
    <LegalShell overline="Legal" title="Privacy Policy" updated="Last updated: July 2026" testid="privacy-page">
        <p>
            LUXATI, a real estate investment and advisory vertical of Ibizo Technologies Private Limited
            ("LUXATI", "we", "us"), respects your privacy. This policy explains what information we collect
            through this website and how it is used.
        </p>
        <div>
            <H>Information We Collect</H>
            <p className="mt-3">
                When you submit an enquiry form, we collect the details you provide — such as your name,
                contact information, preferred market, budget range and message. We also collect basic,
                anonymised usage information to understand how the website is used.
            </p>
        </div>
        <div>
            <H>How We Use It</H>
            <p className="mt-3">
                Enquiry details are used solely to respond to your request, understand your requirements and
                — where relevant — connect you with a developer, sales team or real estate partner. We do not
                sell your personal information.
            </p>
        </div>
        <div>
            <H>Sharing</H>
            <p className="mt-3">
                Where you ask to be connected with a developer or partner regarding a specific opportunity,
                relevant details may be shared with that party for that purpose only.
            </p>
        </div>
        <div>
            <H>Data Retention & Security</H>
            <p className="mt-3">
                Enquiry data is stored securely and retained only as long as needed to serve the purpose for
                which it was collected, or as required by law.
            </p>
        </div>
        <div>
            <H>Your Choices</H>
            <p className="mt-3">
                You may request access to, correction of, or deletion of your personal information by
                contacting us through the details published on our Contact page.
            </p>
        </div>
        <div>
            <H>Changes</H>
            <p className="mt-3">
                This policy may be updated from time to time. The current version will always be available
                on this page.
            </p>
        </div>
    </LegalShell>
);

export const Terms = () => (
    <LegalShell overline="Legal" title="Terms of Use" updated="Last updated: July 2026" testid="terms-page">
        <p>
            These terms govern the use of the LUXATI website, operated as a real estate investment and
            advisory vertical of Ibizo Technologies Private Limited. By using this website you accept these
            terms.
        </p>
        <div>
            <H>Nature of Information</H>
            <p className="mt-3">
                Content on this website — including project descriptions, market commentary and any pricing
                references — is provided for general information only. It does not constitute investment
                advice, financial advice, an offer, or a solicitation. Project details are subject to change
                and must be independently verified with the relevant developer or authority.
            </p>
        </div>
        <div>
            <H>No Guaranteed Returns</H>
            <p className="mt-3">
                Real estate involves risk. Nothing on this website guarantees returns, rental yields,
                appreciation, or availability. Any decision to purchase or invest should be made after
                independent due diligence and professional consultation.
            </p>
        </div>
        <div>
            <H>Role of LUXATI</H>
            <p className="mt-3">
                LUXATI acts as an advisory and connection platform between buyers, investors, developers and
                real estate partners. Purchase agreements are entered into directly between buyers and the
                respective developers or sellers, under the terms and registrations applicable to those
                projects.
            </p>
        </div>
        <div>
            <H>Intellectual Property</H>
            <p className="mt-3">
                All content, branding and design on this website are the property of LUXATI / Ibizo
                Technologies Private Limited and may not be reproduced without permission.
            </p>
        </div>
        <div>
            <H>Limitation of Liability</H>
            <p className="mt-3">
                To the extent permitted by law, LUXATI accepts no liability for decisions made based on
                information presented on this website.
            </p>
        </div>
        <div>
            <H>Governing Law</H>
            <p className="mt-3">
                These terms are governed by the laws of India. Courts at New Delhi shall have jurisdiction.
            </p>
        </div>
    </LegalShell>
);
